export default __webpack_public_path__ + "static/media/logo-osteria-nando-bellinzona-pizzeria-sementina.339de5ee.png";